import React from "react";
import Header from "../../components/header/Header.component";
import Footer from "../../components/footer/Footer.component";

import "../top-airlines/top-airlines.style.css";
import BannerSearchForm from "../../components/flight-search-form/BannerSearchForm.component";
import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";

export const Goa = () => {
  return (
    <>
      <div className="home-banner">
        <div className="cm-page-center">
          <div className="search-banner">
            <h1>Let Airefare bring your dream vacation to new heights.</h1>
            <FlightSearchForm />
          </div>
        </div>
      </div>
      <div className="cm-section cm-page-center">
        {/* <BannerSearchForm depVal={data} urlVal={dataToSend} /> */}
        <div className="ryan-air">
          <div className="ryanair-title">
            <h1>GOA</h1>
          </div>
          <div className="ryanair-content">
            <p>
              The smallest state in India, Goa, is among the most well-known due
              to its rich cultural legacy, hospitable residents, tropical
              climate, stunning beaches, and a wide variety of handicrafts. In
              the 1960s and 1970s, the north of the island became a hippie
              haven, a place to get away from it all that quickly transformed
              into a party area for tourists. A lovely white crescent beach with
              palm palms surrounding the shore, calming blue water, and vibrant
              beach cottages graces the area organically. In light of this, if
              you're considering traveling, don't worry too much—just pack your
              bags and reserve your flights to Goa.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
